import { excelExport } from "components/CommonLib/CommonLib";

export const exportToExcel = (data, fileName, excelOptions) => {
  const newData = [];

  for (let i = 0; i < data.length; i++) {
    const row = {};
    row.날짜 = data[i].base_date;
    row.지점 = data[i].branch_name;

    // 옵션에 따라 추가
    if (excelOptions.mbshp_total_sales) {
      row["회원권 매출"] = data[i].mbshp_total_sales;
    }

    if (excelOptions.other_total_sales) {
      row["부가상품 매출"] = data[i].other_total_sales;
    }

    if (excelOptions.mbshp_and_other_total_sales) {
      row["회원권+부가상품"] = data[i].mbshp_and_other_total_sales;
    }

    if (excelOptions.pt_total_sales) {
      row["PT 매출"] = data[i].pt_total_sales;
    }

    row.매출총계 = data[i].sales_total;
    newData.push(row);
  }

  excelExport(newData, fileName, 13);
};
